import React from "react";
import { Button, Box, CircularProgress } from "@mui/material";

export default function LoadMoreButton({ hasMore, loadingMore, onClick }) {
  if (!hasMore) return null;
  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
      <Button variant="outlined" onClick={onClick} disabled={loadingMore} startIcon={loadingMore ? <CircularProgress size={16} /> : null}>
        {loadingMore ? "Loading..." : "Load More"}
      </Button>
    </Box>
  );
}
